module.exports = __webpack_public_path__ + "static/img/cMRIp1.56cf83ce.png";